/**
 * Validates and normalises a raw driverId route param.
 * Returns a positive integer or null.
 */
export function normalizeDriverIdParam(driverId) {
  if (driverId === null || driverId === undefined || driverId === '') return null;
  const str = String(driverId).trim();
  if (!/^\d+$/.test(str)) return null;
  const id = parseInt(str, 10);
  return id > 0 ? id : null;
}

/**
 * Returns the direct-entry landing path for a given driverId,
 * or null when the id is invalid.
 */
export function buildDirectMainPath(driverId) {
  if (!driverId) return null;
  return `/driverMobile/main/${driverId}`;
}

/**
 * Returns the direct-entry delivery-statements path for a given driverId,
 * or null when the id is invalid.
 */
export function buildDirectDeliveryStatementsPath(driverId) {
  if (!driverId) return null;
  return `/driverMobile/deliveryStatements/${driverId}`;
}

/**
 * Builds the absolute URL to the performance page for a given driverId.
 * Falls back to null when baseUrl is absent (env var not configured).
 */
export function buildPerformanceBackUrl(
  driverId,
  baseUrl = import.meta.env.VITE_PERFORMANCE_PAGE_BASE_URL,
) {
  if (!driverId || !baseUrl) return null;
  const trimmed = baseUrl.replace(/\/$/, '');
  return `${trimmed}/${driverId}`;
}

/**
 * Builds the public salary detail endpoint URL relative to the API root.
 */
export function buildPublicDetailUrl(driverId, fromDate, toDate) {
  if (!driverId || !fromDate || !toDate) return null;
  return `/detail-public/${driverId}?from_date=${fromDate}&to_date=${toDate}`;
}
